import { render, staticRenderFns } from "./TestReportInfo.vue?vue&type=template&id=65d540e6&scoped=true"
import script from "./TestReportInfo.vue?vue&type=script&lang=js"
export * from "./TestReportInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d540e6",
  null
  
)

export default component.exports